import axios from 'axios';
const API = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';

function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return auth.token ? { Authorization: `Bearer ${auth.token}` } : {};
}

// Every template in the catalogue with its on/off state, plus the global switch.
export async function getWatiSettings() {
  const res = await axios.get(`${API}/wati/settings`, { headers: authHeader() });
  return res.data;
}

// templateKey is a template name, or "GLOBAL" for the kill switch.
export async function setWatiSwitch(templateKey, enabled) {
  const res = await axios.put(`${API}/wati/settings/${encodeURIComponent(templateKey)}`,
    { enabled }, { headers: authHeader() });
  return res.data;
}
